const react = require('reactOrig')
react.PropTypes = require('prop-types')

module.exports = react
module.exports.default = react
